export const availableTechnicianDates = "TECHNICIAN_AVAILABLE_DATES";
